<div class="has-text-left modal-title">
    <p class="title is-spaced is-size-3 main-title">Reprise mobile</p>
</div>
<div class="has-text-left">
    <p class="subtitle has-text-tertiary s-size-6">
        Estimez votre ancien téléphone au meilleur prix
        @if (hasBonus) {
            <span>&#32;et bénéficiez d’un bonus reprise</span>
        }
        .
    </p>
    <div class="search-form">
        <div class="columns is-fullwidth">
            <div class="column">
                <div class="field">
                    <div class="control has-icons-right">
                        <input
                            class="input search-input"
                            type="text"
                            placeholder="Marque et modèle de votre ancien téléphone"
                            [(ngModel)]="searchModel"
                            [ngbTypeahead]="typeaheadSearchInput"
                            [resultTemplate]="typeaheadResultTemplate"
                            [inputFormatter]="typeaheadInputFormatter"
                            (selectItem)="selectedItem($event)"
                        />
                        <span class="icon is-small has-text-tertiary">
                            <i
                                [ngClass]="!searchModel ? 'tri-search' : 'tri-times-circle'"
                                class="has-curs-pointer"
                                (click)="clearSearch()"
                            ></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="column">
                <button class="button is-primary" [disabled]="!selectedPhone" (click)="next()">Estimer</button>
            </div>
        </div>
    </div>
    <div class="is-hidden-tablet info-title">
        <ng-container *ngTemplateOutlet="infoTitle"></ng-container>
    </div>
    @if (isMobileMQ) {
        <div class="is-hidden-tablet recovery-slider-mobile">
            <trg-slider [options]="sliderOptions">
                <trg-slider-element>
                    <div class="column is-full has-background-grey-lighter is-borderless box is-flat info-block">
                        <ng-container *ngTemplateOutlet="info1"></ng-container>
                    </div>
                </trg-slider-element>
                <trg-slider-element>
                    <div class="column is-full has-background-grey-lighter is-borderless box is-flat info-block">
                        <ng-container *ngTemplateOutlet="info2"></ng-container>
                    </div>
                </trg-slider-element>
                <trg-slider-element>
                    <div class="column is-full has-background-grey-lighter is-borderless box is-flat info-block">
                        <ng-container *ngTemplateOutlet="info3"></ng-container>
                    </div>
                </trg-slider-element>
                <trg-slider-element>
                    <div class="column is-full has-background-grey-lighter is-borderless box is-flat info-block">
                        <ng-container *ngTemplateOutlet="info4"></ng-container>
                    </div>
                </trg-slider-element>
            </trg-slider>
        </div>
    } @else {
        <div class="has-background-grey-lighter is-borderless box is-flat info-block">
            <ng-container *ngTemplateOutlet="infoTitle"></ng-container>
            <ng-container *ngTemplateOutlet="info1"></ng-container>
            <ng-container *ngTemplateOutlet="info2"></ng-container>
            <ng-container *ngTemplateOutlet="info3"></ng-container>
            <ng-container *ngTemplateOutlet="info4"></ng-container>
        </div>
    }
    <div class="text is-level-2 paragraph has-text-weight-normal">
        <span class="has-text-weight-semibold">Des questions ?</span>
        Retrouvez les réponses de nos experts Bouygues Telecom sur &#32;
        <a
            class="link"
            rel="noopener noreferrer"
            href="https://reprise-recommerce-bouygues.zendesk.com/hc/fr"
            target="_blank"
        >
            notre FAQ
        </a>
    </div>
</div>
<ng-template #infoTitle>
    <p class="has-text-weight-semibold title is-level-3">Comment ça marche ?</p>
</ng-template>
<ng-template #info1>
    <p class="has-text-weight-semibold info-subtitle text is-level-2">1. Estimez la valeur de votre ancien mobile</p>
    @if (hasBonus) {
        <p class="text is-level-2 is-marginless">
            et bénéficiez en plus d’un bonus reprise de
            <span class="has-text-info has-text-weight-semibold">
                {{ bonus | withoutTaxPipe: isWithoutTax }}€{{ isWithoutTax ? ' HT' : '' }}
            </span>
            &#32;pour l’achat d’un {{ modelName }} et la souscription ou renouvellement à un forfait Bouygues Telecom
            {{ forfait_bonus_reprise }}
            <i>(hors séries spéciales)</i>
            .
        </p>
    }
</ng-template>
<ng-template #info2>
    <p class="has-text-weight-semibold info-subtitle text is-level-2">
        2. Finalisez l'achat de votre nouveau téléphone
    </p>
</ng-template>
<ng-template #info3>
    <p class="has-text-weight-semibold info-subtitle text is-level-2">3. Envoyez votre ancien mobile gratuitement</p>
    <p class="text is-level-2 is-marginless">
        a) Recevez à votre adresse de facturation (merci de la vérifier avant de valider votre commande) une enveloppe
        pré-affranchie et pré-adressée à notre partenaire&nbsp;&thinsp;
        <img class="logo-recommerce" src="assets/svg/logo-recommerce.svg" alt="recommerce" />
    </p>
    <p class="text is-level-2 is-marginless">
        b) Joignez à votre envoi le bon de cession, reçu par email après validation de votre reprise.
    </p>
</ng-template>
<ng-template #info4>
    <p class="has-text-weight-semibold info-subtitle text is-level-2">
        4. Recevez le paiement de votre ancien mobile sous 48h
    </p>
    <p class="text is-level-2 is-marginless">
        par virement bancaire après contrôle en atelier par notre partenaire&nbsp;&thinsp;
        <img class="logo-recommerce" src="assets/svg/logo-recommerce.svg" alt="recommerce" />
    </p>
    @if (hasBonus) {
        <p class="text is-level-2 is-marginless">
            Le bonus reprise est lui déduit de votre 2
            <sup>ème</sup>
            ou 3
            <sup>ème</sup>
            facture Bouygues Telecom, si votre mobile repris est validé à {{ 10 | withoutTaxPipe: isWithoutTax }}€{{
                isWithoutTax ? ' HT' : ''
            }}
            minimum.
        </p>
    }
</ng-template>
<ng-template #typeaheadResultTemplate let-phone="result" let-term="search">
    {{ phone.nom }}
</ng-template>
